module.exports = __webpack_public_path__ + "static/youtube-preview.189dfa81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/sections/homePage/entrepreneurs/images/youtube-preview.jpg
// module id = 1673
// module chunks = 168707334958949